<h1 class="title">
  Ajoutez une ou des personne(s) gestionnaire(s) de votre compte
</h1>

<h5 class="title-text-muted text-muted fs-16">
  Saisissez les coordonnées de la ou des personne(s) gestionnaire(s). Vous
  pouvez rajouter de nouvelles personnes ultérieurement dans vos paramètres.
</h5>

<div [formGroup]="form">
  <div formArrayName="persons">
    <ng-container *ngFor="let item of contacts.controls; let i = index">
      <div [formGroupName]="i">
        <div class="border border--1 rounded my-2 finalStepForm">
          <div class="border-bottom border-1 p-3 d-flex justify-content-between align-items-center">
            <mat-label class="card-title">
              Personne gestionnaire du compte N˚{{ i + 1 }}
              <span class="text-secondary"> </span>
            </mat-label>
            <div class="d-flex align-items-center">
              <svg-icon
                class="cursor-pointer"
                (click)="deleteNewContact(i)"
                src="/assets/icons/trash-red.svg"
              ></svg-icon>
            </div>
          </div>
          <div class="px-4 py-2">
            <div class="row my-3" style="padding: 0 12px">
              <mat-label>Email <span class="required">*</span></mat-label>
              <input type="text" [formControlName]="'mail'" [ngClass]="{'invalid-input': item.get('mail')?.touched && item.get('mail')?.invalid}" />
              <div class="required" *ngIf="item.get('mail')?.touched && item.get('mail')?.invalid">
                Ce champ est requis
              </div>
            </div>
            <div class="row align-items-start">
              <div class="col-2">
                <mat-label>Civilité <span class="required">*</span></mat-label>
                <mat-form-field class="dropdownClass" appearance="outline">
                  <mat-select [formControlName]="'civility'">
                    <mat-option *ngFor="let item of civilityOptions" [value]="item.value">
                      {{ item.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="required" *ngIf="item.get('civility')?.touched && item.get('civility')?.invalid">
                  Ce champ est requis
                </div>
              </div>
              <div class="col-4">
                <mat-label>Nom <span class="required">*</span></mat-label>
                <input type="text" style="width: 200px" [formControlName]="'firstName'" [ngClass]="{'invalid-input': item.get('firstName')?.touched && item.get('firstName')?.invalid}" />
                <div class="required" *ngIf="item.get('firstName')?.touched && item.get('firstName')?.invalid">
                  Ce champ est requis
                </div>
              </div>
              <div class="col-5">
                <mat-label>Prénom <span class="required">*</span></mat-label>
                <input type="text" class="ml-px-16 w-px-250" [formControlName]="'lastName'" [ngClass]="{'invalid-input': item.get('lastName')?.touched && item.get('lastName')?.invalid}" />
                <div class="required" *ngIf="item.get('lastName')?.touched && item.get('lastName')?.invalid">
                  Ce champ est requis
                </div>
              </div>
            </div>
            <div class="row align-items-start">
              <div class="d-flex align-items-start">
                <app-custom-dragdrop-image
                class="my-2"
                  text1=""
                  innerClass="rounded border border-1 p-4 me-2"
                  [singleImage]="true"
                  [url]="[item.get('contactPhoto1')?.value]"
                  [smallInput]="true"
                  text3="Ajouter une photo de profil"
                  icon="/assets/icons/camera.svg"
                  (sendImage)="getImage($event, i)"
                  [isDeletble]="true"
                  width="146"
                  height="146"
                ></app-custom-dragdrop-image>
                <div class="row">
                  <div>
                    <mat-label>Téléphone <span class="required">*</span></mat-label>
                    <ngx-intl-tel-input
                    [cssClass]="'custom'"
                    [preferredCountries]="[CountryISO.France]"
                    [selectedCountryISO]="CountryISO.France"
                    [enableAutoCountrySelect]="false"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [maxLength]="phoneMaxLength"
                    [phoneValidation]="true"
                    [inputId]="'my-input-id'"
                    formControlName="numTel"
                  ></ngx-intl-tel-input>
                    <div class="required" *ngIf="item.get('numTel')?.touched && item.get('numTel')?.invalid">
                      Veuillez saisir un numéro valide.
                    </div>
                  </div>
                  <div class="d-flex flex-column my-4">
                    <mat-label>Fonction <span class="required">*</span></mat-label>
                    <input type="text" class="" [formControlName]="'fonction'" [ngClass]="{'invalid-input': item.get('fonction')?.touched && item.get('fonction')?.invalid}" />
                    <div class="required" *ngIf="item.get('fonction')?.touched && item.get('fonction')?.invalid">
                      Ce champ est requis
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="d-flex justify-content-between align-items-center rounded border-1 border p-2 my-2">
  <span class="card-title">Ajouter une personne gestionnaire du compte</span>
  <app-button
    color="primary"
    [srcIcon]="'assets/icons/plus-circle-primary.svg'"
    (click)="addNewContact()"
    [stroked]="true"
    text="Ajouter"
  ></app-button>
</div>
